"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Signature_1 = require("./Signature");
exports.Signature = Signature_1.Signature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1NpZ25hdHVyZS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHlDQUFxQztBQUE3QixnQ0FBQSxTQUFTLENBQUEifQ==